import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	SSID_TEMPLATE_FILTER_EVENT,
	SSID_TEMPLATE_FOCUS_EVENT,
	SSID_TEMPLATE_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.ssid_templates']);

/**
 * Open the SSID Template section.
 * @return {Promise<void>} completion acknowledgement
 */
export function openSsidTemplateSection() {
	return openResourceSection(
		SSID_TEMPLATE_SECTION_EVENT,
		'profile.ssid_templates',
		SECTIONS,
	);
}

/**
 * Apply an SSID Template query.
 * @param {string} query Template query
 * @return {Promise<void>} completion acknowledgement
 */
export function applySsidTemplateFilter(query) {
	if (typeof query !== 'string' || !query.trim()) {
		return Promise.reject(new Error('invalid_ssid_template_filter'));
	}
	return dispatchAcknowledgedEvent(SSID_TEMPLATE_FILTER_EVENT, {
		query: query.trim(),
		resource: 'template',
	});
}

/**
 * Focus a resolved SSID Template.
 * @param {string} entityId opaque Template identifier
 * @return {Promise<void>} completion acknowledgement
 */
export function focusSsidTemplate(entityId) {
	if (typeof entityId !== 'string' || !entityId) {
		return Promise.reject(new Error('invalid_ssid_template_entity'));
	}
	return dispatchAcknowledgedEvent(SSID_TEMPLATE_FOCUS_EVENT, {
		entityId,
		resource: 'template',
	});
}
